export { default as CursosAlumno } from './Listar';
export { default as DetalleCursoAlumno } from './Detalle';
export { default as DetalleClaseAlumno } from './DetalleClase';
export { default as RecuperacionesAlumno } from './Recuperaciones';
